import React from 'react';

export default function ArtistCard(props) {
  const name = props.artist;
  const imageURL = props.imageURL;

  const sendValue = (btn) => {
    props.handleSelectChange({ value: name });
  };
  return (
    <button className="artistCard" value={name} onClick={sendValue}>
      <img src={imageURL} />
      <caption>{name}</caption>
    </button>
  );
}
